import { useMemo } from "react";
import { trpc } from "../trpc";

interface Input {
  enabled?: boolean;
}

export function useAccounts(input?: Input) {
  const { enabled = true } = input || {};

  const { data, isLoading, isPending } = trpc.account.accounts.useQuery(
    undefined,
    { enabled },
  );

  const accounts = useMemo(() => data?.results ?? [], [data]);

  return {
    accounts,
    isLoading,
    isPending,
  };
}
